import { render, staticRenderFns } from "./PagesCountAreaReportVIew.vue?vue&type=template&id=5a590a9e&scoped=true"
import script from "./PagesCountAreaReportVIew.vue?vue&type=script&lang=js"
export * from "./PagesCountAreaReportVIew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a590a9e",
  null
  
)

export default component.exports